import React from "react";
import "./Toaster.scss";
import { ToastContainer } from "react-toastify";

const Toaster = () => {
  return <ToastContainer position="top-center" />;
};

export default Toaster;
